import React from 'react'
import { MDBTable, MDBTableBody } from 'mdbreact';
import BotonesFormulario from '../componentes/BotonesFormulario'
import HeaderTabla from '../componentes/HeaderTabla'

const VerCertificados = ({ data, seleccionaRegistro, baseUrl }) => {

	return (
		<MDBTable hover responsive>
			<HeaderTabla array={['Id', 'Nombre', 'Curso', 'Usuario', '']} />
			<MDBTableBody>

				{data.map((item, index) => {
					return (
						<tr key={index} className="tabla_productos">
							<td>{item.id}</td>
							<td>{item.nombre}</td>
							<td>{item.nombreCurso}</td>
							<td>{item.usuario}</td>
							<td className="tabla_funciones">
								<BotonesFormulario descargar={true} SeleccionarCategoria={seleccionaRegistro} item={item} urlDescarga={baseUrl + item.archivo} />
							</td>
						</tr>
					)
				})}

			</MDBTableBody>
		</MDBTable>
	)
}

export default VerCertificados